import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import toastConfig from "../../../../../components/shared/constants/toaster-config";
import { TEMPLATE_TYPE } from "../constants/template";
import { createTemplate as createTemplateUtility } from "../../../../../utils/broadcast";

export const useTemplate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isTemplateCreated, setIsTemplateCreated] = useState(false);

  const channelId = useSelector((state) => state.campaign.create.channelId);
  const companyId = useSelector((state) => state.user.data?.company?.id);

  const formatTemplateType = (type) => {
    if (!type && typeof type !== 'string') {
      return TEMPLATE_TYPE.TEXT;
    }

    if (type.startsWith("image/")) {
      return TEMPLATE_TYPE.IMAGE;
    } 

    if (type.startsWith("video/")) {
      return TEMPLATE_TYPE.VIDEO;
    } 

    if (type.startsWith("application/pdf")) {
      return TEMPLATE_TYPE.DOCUMENT;
    } 

    return TEMPLATE_TYPE.TEXT;
  }
  
  const createTemplate = async ({
    templateName,
    templateCategory,
    bodyMessage,
    templateFile,
    templateFileUrl,
    templateVariables,
    templateButtons,
    footerMessage,
  }) => {
    const ERROR_MESSAGE = "Error al crear la plantilla, contacte a soporte";

    setIsTemplateCreated(false);
    setError(null);

    if (!companyId) {
      setError(ERROR_MESSAGE)
      toast.error(ERROR_MESSAGE , toastConfig);
      return null;
    }

    if (!channelId) {
      setError(ERROR_MESSAGE)
      toast.error(ERROR_MESSAGE , toastConfig);
      return null;
    }

    try {
      const templateData = {
        name: templateName,
        category: templateCategory,
        lang: 'es',
        text: bodyMessage,
        type: formatTemplateType(templateFile?.type),
        variables: templateVariables ?? [],
        mediaUrl: templateFileUrl,
        buttons: templateButtons,
        ...(footerMessage && { footer: footerMessage })
      };

      setIsLoading(true);

      const templateResult = await createTemplateUtility(companyId, channelId, templateData);
      
      setIsTemplateCreated(true);

      return templateResult;
    } catch (error) {
      if (error.message.includes('ERROR_AT_CREATING_TEMPLATE')) {
        const errorMessage = "Error al crear la plantilla de WhatsApp. Por favor, verifica los datos de tu plantilla.";
        toast.error(errorMessage , toastConfig);
        setError(errorMessage);
        return null;
      } 

      if (error.message.includes('TEMPLATE_NAME_ALREADY_EXISTS')) {
        const errorMessage = "El nombre de la plantilla ya existe. Por favor, elige un nombre diferente.";
        toast.error(errorMessage , toastConfig);
        setError(errorMessage);
        return null;
      }

      toast.error(ERROR_MESSAGE , toastConfig);
      setError(ERROR_MESSAGE);

      return null;
    } finally {
      setIsLoading(false);
    }
  }

  return {
    createTemplate,
    isLoading,
    error,
    isTemplateCreated,
  }
}